module.exports = __webpack_public_path__ + "static/media/2.0778a123.webp";